import { Permissions } from 'config';
import { EVENTS_ENABLED } from './features';

import Dashboard from '../views/dashboards/dashboard';
import AppUser from '../views/users/AppUsers';
import AddUser from '../views/users/AddUser';
import UserProfile from '../views/users/UserProfile';

import CompanyUser from '../views/company_users/CompanyUsers';
import AddCompanyUser from '../views/company_users/AddCompanyUser';

import Groups from '../views/groups';
import AddGroup from '../views/groups/addGroup';

import Offers from '../views/offers/offers';
import OfferStatistics from '../views/offers/OfferStatistics/OfferStatistics';
import OfferCategories from '../views/offer_category/category';

import Companies from '../views/companies/companies';
import AddCompany from '../views/companies/addCompany';
import CompanyCategories from '../views/company_category/category';

import PermissionsView from '../views/acl/permissions';
import RolesView from '../views/acl/roles';

import SpecialUsers from '../views/special_users/SpecialUsers';
import Logs from '../views/activity_logs/logs';
import ActivityLogins from '../views/activity_logins/activityLogins';
import JobBatches from '../views/job_batches/JobBatches';
import FailedJobs from '../views/failed_jobs/FailedJobs';
import SecurityEvents from '../views/security_events/SecurityEvents';
import PublicApiAuditLogs from '../views/public_api_audit_logs/PublicApiAuditLogs';
import Notifications from '../views/notifications/Notifications';

/////////// Company Users /////////////////
import CUProfile from '../views/cu_components/profile/editProfile';
import CUAddOffer from '../views/offers/addOffer';
import EventsList from '../views/events/EventsList/EventsList';
import EventForm from '../views/events/EventForm/EventForm';
import EventResponses from '../views/events/EventResponses/EventResponses';

export default [
    {
        component: Dashboard,
        path: '/',
        titleKey: 'menu.dashboard',
        exact: true,
        permission: [Permissions.DASHBOARD_VIEW],
    },
    {
        component: AppUser,
        path: '/app-users',
        titleKey: 'menu.app_users',
        permission: [Permissions.APP_USER_VIEW],
        roles: ['super_admin'],
    },
    {
        component: AddUser,
        path: '/app-users/:id',
        titleKey: 'menu.add_user',
        permission: [Permissions.APP_USER_CREATE, Permissions.APP_USER_UPDATE],
        roles: ['super_admin'],
    },
    {
        component: UserProfile,
        path: '/user-profile',
        titleKey: 'menu.user_profile',
        permission: [Permissions.APP_USER_DETAILS],
        roles: ['super_admin'],
    },
    {
        component: CompanyUser,
        path: '/company-user',
        titleKey: 'menu.company_users',
        permission: [Permissions.COMPANY_USER_VIEW, Permissions.CU_COMPANY_USER_VIEW],
        showByCondition: (userStore) =>
            userStore.roles &&
            (userStore.roles.includes('company_user') || userStore.roles.includes('group_admin')),
    },
    {
        component: AddCompanyUser,
        path: '/user/new',
        titleKey: 'menu.add_company_users',
        permission: [Permissions.COMPANY_CREATE, Permissions.COMPANY_UPDATE],
    },
    {
        component: AddCompanyUser,
        path: '/user/:id',
        titleKey: 'menu.add_company_users',
        permission: [Permissions.COMPANY_CREATE, Permissions.COMPANY_UPDATE],
    },
    {
        component: Groups,
        path: '/groups',
        titleKey: 'menu.groups',
        permission: [Permissions.GROUP_VIEW, Permissions.CU_GROUP_UPDATE],
    },
    {
        component: AddGroup,
        path: '/group/new',
        titleKey: 'title.add_group',
        permission: [
            Permissions.GROUP_CREATE,
            Permissions.GROUP_UPDATE,
            Permissions.CU_GROUP_UPDATE,
        ],
    },
    {
        component: AddGroup,
        path: '/group/:id',
        titleKey: 'title.edit_group',
        permission: [
            Permissions.GROUP_CREATE,
            Permissions.GROUP_UPDATE,
            Permissions.CU_GROUP_UPDATE,
        ],
    },
    {
        component: SpecialUsers,
        path: '/groups/members',
        titleKey: 'menu.members',
        permission: [Permissions.SPECIAL_USER_VIEW, Permissions.CU_EMPLOYEE_VIEW],
    },
    {
        component: Offers,
        path: '/offers',
        titleKey: 'menu.offers',
        permission: [Permissions.OFFER_VIEW, Permissions.CU_OFFER_VIEW],
    },
    {
        component: OfferStatistics,
        path: '/offers/:id/statistics',
        titleKey: 'menu.offers',
        permission: [Permissions.OFFER_DETAILS, Permissions.CU_OFFER_VIEW],
    },
    {
        component: CUAddOffer,
        path: '/offers/:id',
        titleKey: 'title.edit_offer',
        permission: [
            Permissions.OFFER_CREATE,
            Permissions.OFFER_UPDATE,
            Permissions.CU_OFFER_CREATE,
            Permissions.CU_OFFER_UPDATE,
        ],
    },
    ...(EVENTS_ENABLED
        ? [
              {
                  component: EventsList,
                  path: '/events',
                  titleKey: 'menu.events',
                  exact: true,
                  permission: [Permissions.EVENT_VIEW],
              },
              {
                  component: EventForm,
                  path: '/events/new',
                  titleKey: 'events.new',
                  permission: [Permissions.EVENT_CREATE, Permissions.EVENT_UPDATE],
              },
              {
                  component: EventResponses,
                  path: '/events/:id/responses',
                  titleKey: 'events.responses',
                  permission: [Permissions.EVENT_VIEW],
              },
              {
                  component: EventForm,
                  path: '/events/:id',
                  titleKey: 'events.edit',
                  permission: [Permissions.EVENT_CREATE, Permissions.EVENT_UPDATE],
              },
          ]
        : []),
    {
        component: OfferCategories,
        path: '/offer-categories',
        titleKey: 'menu.categories',
        permission: [Permissions.CATEGORY_VIEW],
    },
    {
        component: Companies,
        path: '/companies',
        titleKey: 'menu.companies',
        permission: [Permissions.COMPANY_VIEW, Permissions.CU_COMPANY_VIEW],
    },
    {
        component: AddCompany,
        path: '/add-company',
        titleKey: 'menu.add_company',
        permission: [Permissions.COMPANY_CREATE, Permissions.COMPANY_UPDATE],
    },

    {
        component: AddCompany,
        path: '/company/:id',
        titleKey: 'title.company_preview',
        permission: [
            Permissions.COMPANY_CREATE,
            Permissions.COMPANY_UPDATE,
            Permissions.CU_COMPANY_UPDATE,
        ],
    },
    {
        component: CompanyCategories,
        path: '/company-categories',
        titleKey: 'menu.categories',
        permission: [Permissions.COMPANY_VIEW],
    },
    {
        component: Logs,
        path: '/logs',
        titleKey: 'menu.logs',
        permission: [Permissions.LOG_VIEW],
    },
    {
        component: ActivityLogins,
        path: '/logins',
        titleKey: 'menu.logins',
        permission: [Permissions.ACTIVITY_LOGIN_VIEW],
    },
    {
        component: JobBatches,
        path: '/job-batches',
        titleKey: 'menu.job_batches',
        permission: [Permissions.LOG_VIEW],
        roles: ['super_admin'],
    },
    {
        component: FailedJobs,
        path: '/failed-jobs',
        titleKey: 'menu.failed_jobs',
        permission: [Permissions.LOG_VIEW],
        roles: ['super_admin'],
    },
    {
        component: SecurityEvents,
        path: '/security-events',
        titleKey: 'menu.security_events',
        permission: [Permissions.LOG_VIEW],
        roles: ['super_admin'],
    },
    {
        component: PublicApiAuditLogs,
        path: '/public-api-audit-logs',
        titleKey: 'menu.public_api_audit_logs',
        permission: [Permissions.PUBLIC_API_AUDIT_VIEW],
        roles: ['super_admin'],
    },
    {
        component: Notifications,
        path: '/push-notifications',
        titleKey: 'menu.push_notifications',
        permission: [Permissions.LOG_VIEW],
        roles: ['super_admin'],
    },
    {
        component: PermissionsView,
        path: '/permissions',
        titleKey: 'menu.permissions',
        permission: [Permissions.PERMISSION_VIEW],
    },
    {
        component: RolesView,
        path: '/roles',
        titleKey: 'menu.roles',
        permission: [Permissions.ROLE_VIEW],
    },

    //////////////////////////////////////////////////
    //////////// Company users ///////////////////////

    {
        component: Dashboard,
        path: '/',
        titleKey: 'menu.dashboard',
        exact: true,
        permission: [Permissions.CU_DASHBOARD_VIEW],
    },
    {
        component: CUProfile,
        path: '/profile',
        titleKey: 'menu.my_profile',
        permission: [Permissions.CU_PROFILE_UPDATE],
    },
    {
        component: Offers,
        path: '/offers',
        titleKey: 'menu.my_offers',
        exact: true,
        permission: [Permissions.CU_OFFER_VIEW],
    },
    // {
    //     component: CUCustomMembers,
    //     path: "/my_members",
    //     title: "My employees",
    //     exact: true,
    //     permission: [Permissions.CU_CUSTOM_EMPLOYEE_VIEW],
    // },
    // {
    //     component: CUB2B,
    //     path: "/b2b",
    //     title: "B2B offers",
    //     exact: true,
    //     permission: [Permissions.CU_B2B_VIEW],
    // },
];
